import { PortfolioStats, SanityGlobalSocialStats } from 'types/sanity/marketing-components';
import { apiRequest } from '@utils/request';
import { SanityGraphQLResponse } from 'types/sanity';
import { GlobalSocialStats as SocialStats } from '@sanity/graphql/queries/global-social-stats';
import { useQueryWithContext } from '@utils/villus';

type SanitySocialStatsResponse = SanityGraphQLResponse<SanityGlobalSocialStats, 'allGlobalSocialStats'>;

export async function getSocialStats(context?: string): Promise<SanityGlobalSocialStats | null> {
	const { data } = await useQueryWithContext<SanitySocialStatsResponse>({
		query: SocialStats,
		baseTag: 'social_stats',
		contextTag: context
	}).execute();

	return data?.allGlobalSocialStats[0] ?? null;
}

export async function getPortfolioStats(): Promise<PortfolioStats> {
	const reitElementStrategyTotalsUrl = apiRequest.get(`/reit-elements/strategy-totals`);

	const reitsTotalsResponse = await reitElementStrategyTotalsUrl;

	const sanityStatsResponse: SanityGlobalSocialStats | undefined =
		(await getSocialStats('portfolio-stats')) ?? undefined;

	return {
		sanityStats: sanityStatsResponse,
		reitsTotals: reitsTotalsResponse.data
	};
}
